import React, { useEffect, useState } from 'react'
import { getGameFromSlug } from '../../api/user';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import ChatHistoryPage from '../ChatHistoryPage';
import { toast } from 'react-toastify';
import DashboardHeader from '../../components/Other/DashboardHeader';
import PageHeaderTitle from '../../components/pages/PageHeaderTitle';

const GameMessage = () => {

    const [sidebarToggle] = useOutletContext();
    const { slug, user_id } = useParams();
    const [game, setGame] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate()

    useEffect(() => {

        const checkGameDates = (start_date, end_date) => {

            const endDate = new Date(end_date.replace(" ", "T")); // Parse game.end_date
            const startDate = new Date(start_date.replace(" ", "T")); // Parse game.start_date
            const today = new Date(); // Get today's date
            today.setHours(0, 0, 0, 0); // Set time to midnight to ignore time component

            if (today >= startDate && today <= endDate) {
                return true;
            } else {
                return false;
            }

        }

        const fetchGameId = async (slug) => {
            try {
                const response = await getGameFromSlug({ slug });
                const gameData = response?.data?.data;

                if (gameData) {

                    if (checkGameDates(gameData.start_date, gameData.end_date)) {
                        setGame(gameData);
                        setLoading(true);
                    }
                    else {
                        setGame(gameData);
                        setLoading(true);
                        // toast.error("League is not active");
                        // navigate("/contest/my-games");
                        // navigate("/contest/my-games", { state: { viewMode: "member" } });
                    }
                } else {
                    // toast.error("League not found");
                    // navigate("/contest/my-games");
                    // navigate("/contest/my-games", { state: { viewMode: "member" } });
                }

            } catch (error) {
                console.error("Error fetching game ID:", error);
            }
        };

        fetchGameId(slug);

    }, [slug]);

    return (<>

        {
            loading && (
              <>
                <ChatHistoryPage game_id={game.id} slug={slug} profile_id={user_id} />
                </>
            )
        }
    </>
    );
}

export default GameMessage


